import { NavigationService } from '../NavigationService';
import './../StringExtensions';

export class NavigationModel {
    navigation: NavigationService;
    constructor(navigation: NavigationService) {
        this.navigation = navigation;
    }
    get phrase() {
        return this.navigation.getQuery('phrase') || '';
    }
    set phrase(value: string) {
        this.navigation.setQuery('phrase', value);
    }
    get page() {
        const page = this.navigation.getQuery('page');
        const parsed = parseInt(page || '1', 10);
        if (parsed < 1) {
            return 0;
        }
        else {
            return parsed - 1;
        }
    }
    set page(value: number) {
        if (value < 1) {
            this.navigation.setQuery('page', undefined);
        }
        else {
            this.navigation.setQuery('page', (value + 1).toString());
        }
    }
    getTab(def: string) {
        const value = this.navigation.getQuery('tab') || def;
        return value.toLocaleLowerCase();
    }
    setTab(value: string, def: string) {
        if (value.equalsIgnoreCase(def)) {
            this.navigation.setQuery('tab', undefined);
        }
        else {
            this.navigation.setQuery('tab', value.toLocaleLowerCase());
        }
    }
}
